import { Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ClickableIcon from '../../base/ui/components/web/ClickableIcon';
import { IconCloseLarge } from '../../base/icons/svg';
import '../style.css';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => {
    return {
        tabHeaderMenu: {
            fontSize: 20,
            fontWeight: 700,
            color: theme.palette?.primary10,
            fontFamily: 'Sarabun, Tahoma, Arial'
        }
    };
});
const HeaderMenuController = ({ headerTitle = 'menuController.header', closeDialog }) => {
    const { cx, classes } = useStyles();
    const { t } = useTranslation();
    const onClosePane = useCallback(() => {
        closeDialog();
    }, []);
    return (React.createElement("div", { className: 'header-menu' },
        React.createElement(Typography, { className: cx(classes.tabHeaderMenu) }, t(headerTitle)),
        React.createElement(ClickableIcon, { className: 'icon-close-large', accessibilityLabel: t('participantsPane.close', 'Close'), icon: IconCloseLarge, onClick: onClosePane })));
};
export default HeaderMenuController;
